import { Component, EventEmitter, Output, Input } from '@angular/core';
import { Common } from '../../shared/common';
import { Voter } from 'src/app/models/Voter';

@Component({
  selector: 'voters-delete-popup',
  templateUrl: './voters-delete-popup.component.html',
  styleUrls: ['./voters-delete-popup.component.less', '../../shared/common.less']
})
export class VotersDeletePopupComponent {
  @Output() isClosed = new EventEmitter<boolean>();
  @Input() voters: Array<Voter> = [];
  @Input() isAssessors = false;

  onDismiss(event: boolean) {
    this.isClosed.emit(event);
  }
  constructor(public common: Common) { }

}
